"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _winDoc = require("win-doc");
// @ts-check

/**
 * @param {HTMLElement} el
 * @param {string} styleKey
 * @returns {undefined|string|number}
 */
var getStyle = function getStyle(el, styleKey) {
  var _win;
  if (!(0, _winDoc.hasWin)()) {
    return;
  }
  var oDoc = (0, _winDoc.doc)();
  var currentStyle = (_win = (0, _winDoc.win)()) === null || _win === void 0 ? void 0 : _win.getComputedStyle(el, null);
  var styleValue = "";
  if (currentStyle) {
    styleValue = currentStyle[styleKey];
  } else if (oDoc.defaultView && oDoc.defaultView.getComputedStyle) {
    styleValue = oDoc.defaultView.getComputedStyle(el, null).getPropertyValue(styleKey);
  }
  if (styleValue && styleValue.toLowerCase) {
    return styleValue.toLowerCase();
  } else {
    return styleValue;
  }
};
var _default = getStyle;
exports["default"] = _default;
module.exports = exports.default;